export var MessageListeners;
(function (MessageListeners) {
    MessageListeners["changeNetwork"] = "changeNetwork";
    MessageListeners["authenticationCompleted"] = "authenticationCompleted";
    MessageListeners["followerAuthenticationCompleted"] = "followerAuthenticationCompleted";
    MessageListeners["walletInactivityLoggedOut"] = "walletInactivityLoggedOut";
    MessageListeners["walletDeviceDeletedLoggedOut"] = "walletDeviceDeletedLoggedOut";
    MessageListeners["pendingTransaction"] = "pendingTransaction";
    MessageListeners["completedTransaction"] = "completedTransaction";
    MessageListeners["erc20TokenBalanceChanged"] = "erc20TokenBalanceChanged";
    MessageListeners["erc20TokenFiatPriceChanged"] = "erc20TokenFiatPriceChanged";
    MessageListeners["ethBalanceChanged"] = "ethBalanceChanged";
    MessageListeners["ethFiatPriceChanged"] = "ethFiatPriceChanged";
    MessageListeners["changeCurrency"] = "changeCurrency";
    MessageListeners["isKycVerified"] = "isKycVerified";
    MessageListeners["kycProcessCancelled"] = "kycProcessCancelled";
    MessageListeners["websocketConnected"] = "websocketConnected";
    MessageListeners["websocketDisconnected"] = "websocketDisconnected";
    MessageListeners["newBlock"] = "newBlock";
    MessageListeners["playerProtectionUpdated"] = "playerProtectionUpdated";
    MessageListeners["walletTracking"] = "walletTracking";
    MessageListeners["authenticationPopUpClosed"] = "authenticationPopUpClosed";
    MessageListeners["restoreAuthenticationCompleted"] = "restoreAuthenticationCompleted";
    MessageListeners["transactionReplaced"] = "transactionReplaced";
    MessageListeners["appJwtExtended"] = "appJwtExtended";
})(MessageListeners || (MessageListeners = {}));
//# sourceMappingURL=message-listeners.js.map